/**
 * Up to three application questions for a job. Each is answered in writing
 * or on video, and can be required. Applicants see them before they apply.
 */

import {inputClass} from './formKit'

export const MAX_JOB_QUESTIONS = 3

const SUGGESTED = [
  'Tell us about yourself and your style.',
  'Do you have your own clients?',
  'What are you looking for in your next salon?',
  'Show us a look you are proud of.',
]

const Toggle = ({options, value, onChange}) => (
  <div className="inline-flex rounded-full border border-line p-0.5">
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        onClick={() => onChange(o.value)}
        className={`px-3 py-1 rounded-full text-xs font-semibold transition-colors ${
          value === o.value
            ? 'bg-sharpenn-blush text-sharpenn-coral'
            : 'text-content-tertiary hover:text-content-primary'
        }`}
      >
        {o.label}
      </button>
    ))}
  </div>
)

const JobQuestionsEditor = ({questions, onChange}) => {
  const update = (i, patch) =>
    onChange(questions.map((q, j) => (j === i ? {...q, ...patch} : q)))
  const remove = (i) => onChange(questions.filter((_, j) => j !== i))
  const add = (name = '') =>
    questions.length < MAX_JOB_QUESTIONS &&
    onChange([...questions, {name, answerKind: 'text', required: true}])

  const unused = SUGGESTED.filter((s) => !questions.some((q) => q.name === s))

  return (
    <div className="space-y-3">
      {questions.map((q, i) => (
        <div
          key={i}
          className="rounded-xl border border-line-subtle p-3 space-y-2"
        >
          <div className="flex gap-2">
            <input
              value={q.name}
              onChange={(e) => update(i, {name: e.target.value})}
              maxLength={500}
              placeholder={`Question ${i + 1}`}
              className={inputClass}
            />
            <button
              type="button"
              aria-label="Remove question"
              onClick={() => remove(i)}
              className="px-2 text-content-tertiary hover:text-content-primary"
            >
              ✕
            </button>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <Toggle
              value={q.answerKind}
              onChange={(answerKind) => update(i, {answerKind})}
              options={[
                {value: 'text', label: 'Written answer'},
                {value: 'video', label: 'Video answer'},
              ]}
            />
            <Toggle
              value={q.required ? 'required' : 'optional'}
              onChange={(v) => update(i, {required: v === 'required'})}
              options={[
                {value: 'required', label: 'Required'},
                {value: 'optional', label: 'Optional'},
              ]}
            />
          </div>
        </div>
      ))}

      {questions.length < MAX_JOB_QUESTIONS && (
        <div className="space-y-2">
          {unused.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {unused.map((s) => (
                <button
                  key={s}
                  type="button"
                  onClick={() => add(s)}
                  className="px-3 py-1.5 rounded-full border border-dashed border-line-strong text-xs text-content-secondary hover:bg-surface-hover"
                >
                  + {s}
                </button>
              ))}
            </div>
          )}
          <button
            type="button"
            onClick={() => add()}
            className="text-sm font-semibold text-sharpenn-coral"
          >
            + Write your own question
          </button>
        </div>
      )}
    </div>
  )
}

export default JobQuestionsEditor
